module.exports = __webpack_public_path__ + "static/24-thumb-6050e3290f0229130cf31545aefd00a9.jpg";